@let isLoading = loadingService.isLoading$(this) | async;

<form [formGroup]="form" [waiting]="isLoading">
  <div class="row h-full">
    <div class="grow">
      @if (!isBulkOperation) {
        <icz-entity-info class="block mb-16" [entity]="data.selectedObjects[0]"></icz-entity-info>
      }
      <icz-date-picker [label]="data.isSuspend ? 'Datum přerušení řízení' : 'Datum obnovení řízení'" formControlName="date" [selectableDates]="selectableDates"></icz-date-picker>
      <icz-form-field [label]="data.isSuspend ? 'Důvod přerušení řízení' : 'Důvod obnovení řízení'" formControlName="reason"></icz-form-field>
      @if (isFileSuspension) {
        <icz-form-field type="integer" label="Lhůta pro obnovení (počet dnů)" formControlName="renewalDeadline">
          <icz-icon
            suffix size="small" svgIcon="info"
            iczTooltip="Délka časového intervalu v kalendářních dnech, před jehož uplynutím může systém upozornit Zpracovatele spisu na blížící se termín Obnovení řízení"
          ></icz-icon>
        </icz-form-field>
      }
    </div>
  </div>
</form>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
    [disabled]="isLoading"
    (onAction)="submit()"
    primary [label]="data.isSuspend ? 'Přerušit řízení' : 'Obnovit řízení'"
  ></icz-button>
  <icz-button rightButtons
    [disabled]="isLoading"
    (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
